export default {
  maxLastId: state => {
    if (state.menus.length === 0) return 1
    return Math.max.apply(Math, state.menus.map(function (o) {
      return parseInt(o.id);
    }))
  }
}
